<template>
	<div class="userinfo" ref="height_top" v-bind:style="{ height: tableHeight + 'px' }" style="overflow: auto;margin-top:-3px">
		<el-row>
				<el-col :span="12">
				</el-col>
				<el-col :span="12">
				</el-col>
			</el-row>
		<div class="form" style="">
			<el-row>
				<el-col :span="24">
					<el-row style="">
						<el-col class="user_name" :xs="{span: 24, offset: 0}" :sm="{span: 12, offset: 0}" :md="{span: 12, offset: 0}" :lg="{span: 12, offset:0}" :xl="{span: 12, offset: 0}">
							<el-form style="margin-right:2.625rem" :model="form" ref="formData" :rules="rules" label-width="120px" label-position="right">
								<el-col :span="24" class="" style="margin-bottom:10px">
									<div style="position: absolute;width:30px;height:30px;background-color:#618AF2;border-radius: 30px;line-height:30px;top: 4px;">
										<img round width="20px" style="margin-top:5px;margin-left:5px" height="20px" src="../../assets/img/huiyuan.png" />
									</div>
									<div style="width:100px;height:20px;background-color:#89ADF7;border-radius: 30px;margin-top:10px;line-height:20px;text-align:right">
										<span style="font-size:12px;padding-right:10px;color:#fff">
											个人用户
										</span>
									</div>
									<div style="margin-left:10px;margin-top:10px">
										<span style="font-size:16px;font-weight: bold;">ID:</span>
										<span>
											{{userinfo.code}}
										</span>
									</div>
								</el-col>
								<el-col :span="24" class="" v-if="state==2">
									<el-alert :title="'账户已被冻结,'+'冻结至'+expire_date" type="error" />
								</el-col>
								<!-- :offset="1" -->
								<el-col :span="24" class="triggerFileInput" style="text-align: center;">
									<el-avatar :size="150" @click="triggerFileInput" :src="croppedAvatarUrl" />
								</el-col>
								<el-col :span="24" class="userinfo_boder">
									<el-form-item label="联系人：" prop="">
										<el-input v-model="form.linkman" :disabled="save_info" :input-style="{ border: 'none', outline: 'none' }" />
									</el-form-item>
								</el-col>
								<el-col :span="24" class="userinfo_boder">
									<el-form-item label="手机号：">
										<el-input v-model="form.mobile" disabled />
									</el-form-item>
								</el-col>
								<el-col :span="24" class="userinfo_boder">
									<el-row>
										<el-col :xs="16" :sm="14" :md="14" :lg="14" :xl="12">
											<el-form-item label="公司地址：" prop="">
												<el-select v-model="form.province_id" :disabled="save_info" placeholder="请选择省份" @change="changeProvices">
													<el-option :label="item.name" v-for="(item,key) in provices" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
										</el-col>
										<el-col :xs="4" :sm="5" :md="5" :lg="5" :xl="6">
											<el-select v-model="form.city_id" :disabled="save_info" placeholder="请输入城市" @change="changeCity">
												<el-option :label="item.name" v-for="(item,key) in city" :value="item.id"></el-option>
											</el-select>
										</el-col>
										<el-col :xs="4" :sm="5" :md="5" :lg="5" :xl="6">
											<el-select v-model="form.district_id" :disabled="save_info" placeholder="请输入区" @change="changeDistrict">
												<el-option :label="item.name" v-for="(item,key) in district" :value="item.id"></el-option>
											</el-select>
										</el-col>
									</el-row>
								</el-col>
								<el-col :span="24" class="userinfo_boder">
									<el-form-item label="详细地址：" prop="" v-if="form.province_city">
										<el-input v-model="form.company_address" :disabled="save_info" placeholder="请输入公司地址">
											<template #prepend>{{form.province_city}}</template>
										</el-input>
									</el-form-item>
									<el-form-item label="详细地址：" prop="" v-else>
										<el-input v-model="form.company_address" :disabled="save_info" placeholder="请输入公司地址">
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="24" class="userinfo_boder">
									<el-form-item label="信息公开：">
										<el-switch :disabled="save_info" v-model="form.is_open" size="large" active-text="公开信息" inactive-text="需交换信息" />
									</el-form-item>
								</el-col>
							</el-form>
							<!-- style="border-left: 1px solid var(--el-border-color);" -->
						</el-col>
						<el-col class="user_company box"  :sm="{span: 24, offset: 0}" :md="{span: 12, offset: 0}" :lg="{span: 12, offset: 0}" :xl="{span: 12, offset: 0}">
							<el-form :model="form1" ref="formData1" :rules="rules1" label-width="120px" label-position="right">
								<div style="margin: 0px 0.625rem 0px 1.625rem;">
									<el-row>
										<el-col :span="6" class="" style="margin-bottom:30px;">
										<div style="margin-left: 20px;">
											<div style="position: absolute;width:30px;height:30px;background-color:#618AF2;border-radius: 30px;line-height:30px;top: 4px;">
												<img round width="20px" style="margin-top:5px;margin-left:5px" height="20px" src="../../assets/img/huiyuan.png" />
											</div>
											<div style="width:100px;height:20px;background-color:#89ADF7;border-radius: 30px;margin-top:10px;line-height:20px;text-align:right">
												<span style="font-size:12px;padding-right:10px;color:#fff">企业用户</span>
											</div>
										</div>
											
										</el-col>
										<el-col :span="18" class="" style="text-align:right;margin-top:10px;" v-if="form1.bus_state==1">
											<span style="color:red;font-weight: bold;font-size: 1.5rem;">
												已提交，等待审核中
											</span>
										</el-col>
										<el-col :span="18" style="text-align:right;margin-top:10px" class="" v-else-if="form1.bus_state==2">
											<span style="margin-top:15px;color:#67C23A;font-weight: bold;font-size: 1.5rem;">
												已认证
											</span>
										</el-col>
										<el-col :span="18" style="text-align:right;margin-top:10px" v-else-if="form1.bus_state==3">
											<span style="color:red;font-weight: bold;font-size: 1.5rem;">
												已拒绝审核
											</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="企业名称：" prop="companyName">
												<el-input v-model="form1.companyName" :disabled="save_info1" placeholder="" />
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="企业类型：" prop="companyType">
												<el-select v-model="form1.companyType" :disabled="save_info1" placeholder="" @change="changeDistrict">
													<el-option :label="'代理贸易'" :value="'1'"></el-option>
													<el-option :label="'生产制造'" :value="'2'"></el-option>
												</el-select>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="法人代表：" prop="legalPerson">
												<el-input v-model="form1.legalPerson" :disabled="save_info1" placeholder="" />
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="纳税税号：" prop="taxCode">
												<el-input v-model="form1.taxCode" :disabled="save_info1" placeholder="" />
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="开户银行：" prop="bankName">
												<el-input v-model="form1.bankName" :disabled="save_info1" placeholder="" />
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="银行账号：" prop="bankAccount">
												<el-input v-model="form1.bankAccount" :disabled="save_info1" placeholder="" />
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-form-item label="开票地址：" prop="invoiceAddr">
												<el-input v-model="form1.invoiceAddr" :disabled="save_info1" placeholder="" />
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="开票电话：" prop="invoicePhone">
												<el-input v-model="form1.invoicePhone" :disabled="save_info1" placeholder="" />
											</el-form-item>
										</el-col>
									</el-row>
									<el-row class="company_img">
										<!-- 营业执照上传 ✅ 核心修复2：补全prop属性 -->
										<el-col :span="8">
											<el-form-item label="营业执照：" prop="img_business">
												<el-upload :disabled="save_info1" class="avatar-uploader" :show-file-list="false" action="#" accept="image/jpeg,image/png,image/webp,image/gif" :http-request="handleBizLicenseUpload">
													<img v-if="form1.img_business" :src="form1.img_business" class="avatar" />
													<el-icon v-else class="avatar-uploader-icon">
														<Plus />
													</el-icon>
												</el-upload>
											</el-form-item>
										</el-col>
										<!-- 企业授权书上传 ✅ 核心修复2：补全prop属性 -->
										<el-col :span="8">
											<el-form-item label="企业授权书：" prop="authFileUrl">
												
												<el-upload :disabled="save_info1" class="avatar-uploader" :show-file-list="false" action="#" accept="image/jpeg,image/png,image/webp,image/gif" :http-request="handleAuthFileUpload">
													<img v-if="form1.authFileUrl" :src="form1.authFileUrl" class="avatar" />
													<el-icon v-else class="avatar-uploader-icon">
														<Plus />
													</el-icon>
												</el-upload>
												
											</el-form-item>
										</el-col>
										<!-- 企业资质上传 ✅ 核心修复2：补全prop属性 -->
										<el-col :span="8">
											<el-form-item label="企业资质：" >
												<el-upload :disabled="save_info1" class="avatar-uploader" :show-file-list="false" action="#" accept="image/jpeg,image/png,image/webp,image/gif" :http-request="handleQualificationUpload">
													<img v-if="form1.img_qualily" :src="form1.img_qualily" class="avatar" />
													<el-icon v-else class="avatar-uploader-icon">
														<Plus />
													</el-icon>
												</el-upload>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
									<el-col :span="8" :offset="8">
									<div class="authFileUrl_w">
    												<el-link type="primary" style="margin-left: 19px;" :href="this.$axios.defaults.baseURL + '/yunsys/download?name=auth'" target="_blank">企业授权函模板下载</el-link></div>
									</el-col>
									
									</el-row>
								</div>
							</el-form>
						</el-col>
					</el-row>
					<el-row style="margin-top:20px">
						<el-col class="" :xs="{span: 24, offset: 0}" :sm="{span: 12, offset: 0}" :md="{span: 12, offset: 0}" :lg="{span: 12, offset:0}" :xl="{span: 12, offset: 0}">
							<el-col :span="22" style="text-align: right;margin-top:5px" class="bottom">
								<el-button type="danger" @click="save_info=true;getusermsg()" v-if="!save_info">取消</el-button>
								<el-button color="#ff8a5c" style="color:#fff" @click="save_info=false" v-if="save_info">编辑</el-button>
								<el-button color="#ff8a5c" style="color:#fff" @click="saveuser" v-else :loading='loading'>保存</el-button>
							</el-col>
						</el-col>
						<el-col class="" style="" :sm="{span: 24, offset: 0}" :md="{span: 12, offset: 0}" :lg="{span: 12, offset: 0}" :xl="{span: 12, offset: 0}">
							<el-col :span="22" style="text-align: right;margin-top:5px" class="bottom">
								<el-button type="danger" @click="save_info1=true;getusermsg()" v-if="!save_info1">取消</el-button>
								<el-button color="#ff8a5c" style="color:#fff" @click="save_info1=false" v-if="save_info1">编辑</el-button>
								<el-button color="#ff8a5c" style="color:#fff" @click="saveuser_company" v-else :loading='loading'>保存</el-button>
							</el-col>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-row>
			</el-row>
		</div>
		<input ref="fileInput" type="file" accept="image/*" @change="handleFileChange" style="display: none">
		<!-- 裁剪弹窗 -->
		<el-dialog title="裁剪头像" v-model="showCropperModal" width="800px" :close-on-click-modal="false">
			<div class="cropper-container">
				<img ref="imageElement" :src="imageSource" class="cropper-image">
			</div>
			<span slot="footer" class="dialog-footer" center="right">
				<el-button @click="showCropperModal = false">取 消</el-button>
				<el-button type="primary" @click="confirmCrop">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
	components: {},
	data() {

		return {
			uploadAccept: 'image/jpeg,image/png,image/gif,image/webp',
			imageUrl: '',
			form_company: {},
			expire_date: '',
			state: '',
			save_info: true, //需求，加载页面后所有输入框都不可以修改，点击编辑后可修改，并且编辑 变为保存，修改后点击保存才可保存
			save_info1: true,
			district: [],
			provices: [],
			city: [],
			tableHeight: '',

			loading: false,
			form: {
				name: '',
				radio: '1',
			},
			user_id: '',
			username: '',
			mobile: '',
			code: '',
			rules: { //
				username: [{
					required: true,
					message: '请填写昵称',
					trigger: 'blur'
				}],
				legal_person: [{
					required: true,
					message: '请填写收货人',
					trigger: 'blur'
				}],
				address: [{
					required: true,
					message: '请填写收货地址',
					trigger: 'blur'
				}],
				tel: [{
					required: true,
					message: '请填写收货电话',
					trigger: 'blur'
				}],
				linkman: [{
					required: true,
					message: '请填写联系人',
					trigger: 'blur'
				}],
				province_id: [{
					required: true,
					message: '请选择省份',
					trigger: 'change'
				}],
				city_id: [{
					required: true,
					message: '请选择城市',
					trigger: 'blur'
				}],
				company_address: [{
					required: true,
					message: '请填写公司地址',
					trigger: 'blur'
				}],
			},
			rules1: {
				companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
				companyType: [{ required: true, message: '请输入企业类型', trigger: 'change' }],
				legalPerson: [{ required: true, message: '请输入法定代表人', trigger: 'blur' }],
				taxCode: [{ required: true, message: '请输入纳税税号', trigger: 'blur' }],
				bankName: [{ required: true, message: '请输入开户银行', trigger: 'blur' }],
				bankAccount: [{ required: true, message: '请输入银行账号', trigger: 'blur' }],
				invoiceAddr: [{ required: true, message: '请输入开票地址', trigger: 'blur' }],
				invoicePhone: [{ required: true, message: '请输入开票电话', trigger: 'blur' }],
				img_business: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
				authFileUrl: [{ required: true, message: '请上传企业授权书', trigger: 'change' }],
				img_qualily: [{ required: true, message: '请上传企业资质', trigger: 'change' }]
			},
			form1: {
				companyName: '',
				companyType: '',
				legalPerson: '',
				taxCode: '',
				bankName: '',
				bankAccount: '',
				invoiceAddr: '',
				invoicePhone: '',
				img_business: '',
				authFileUrl: '',
				img_qualily: ''
			},
			userinfo: {},
			showCropperModal: false,
			imageSource: '',
			cropper: null,
			croppedAvatarUrl: require('../../assets/img/user.png')
		}
	},
	props: {
		// 可传入默认头像URL
		defaultAvatar: {
			type: String,
			default: ''
		}
	},

	updated() {

	},


	mounted() {
		// 初始化cropper实例
		this.initCropper();
	},

	activated() {

	},
	created() {
		this.getProvices();
		this.getusermsg();
		this.tableHeight_fun();

	},
	watch: {

	},
	methods: {
		// 营业执照上传转base64
		handleBizLicenseUpload(file) {
			this.fileToBase64(file.file, (base64Str) => {
				this.form1.img_business = base64Str;
				// ✅ 核心修复3：赋值后，主动刷新当前字段的校验状态，告诉表单已经有值了
				this.$refs.formData1.clearValidate('img_business');
			});
		},
		// 企业授权书上传转base64
		handleAuthFileUpload(file) {
			this.fileToBase64(file.file, (base64Str) => {
				this.form1.authFileUrl = base64Str;
				this.$refs.formData1.clearValidate('authFileUrl');
			});
		},
		// 企业资质上传转base64
		handleQualificationUpload(file) {
			this.fileToBase64(file.file, (base64Str) => {
				this.form1.img_qualily = base64Str;
				this.$refs.formData1.clearValidate('img_qualily');
			});
		},
		// 公共方法：文件流转Base64 核心方法
		fileToBase64(file, callback) {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = (e) => {
				callback(e.target.result);
			};
			reader.onerror = () => {
				this.$message.error('图片解析失败，请重新上传！');
			};
		},
		triggerFileInput() {
			if (this.save_info) {
				return false;
			}
			this.$refs.fileInput.click();
		},
		// 处理文件选择
		handleFileChange(event) {

			const file = event.target.files[0];
			if (!file) return;

			// 验证文件类型
			if (!file.type.match('image.*')) {
				this.$message.error('请选择图片文件');
				return;
			}

			// 验证文件大小 (限制2MB)
			if (file.size > 2 * 1024 * 1024) {
				this.$message.error('图片大小不能超过2MB');
				return;
			}

			// 读取文件
			const reader = new FileReader();
			reader.onload = (e) => {
				this.imageSource = e.target.result;
				this.showCropperModal = true;
				// 重置cropper
				this.$nextTick(() => {
					if (this.cropper) {
						this.cropper.replace(this.imageSource);
					} else {
						this.initCropper();
					}
				});
			};
			reader.readAsDataURL(file);
		},
		// 初始化cropper
		initCropper() {
			this.$nextTick(() => {
				if (this.$refs.imageElement) {
					this.cropper = new Cropper(this.$refs.imageElement, {
						aspectRatio: 1, // 正方形
						viewMode: 1, // 限制裁剪框不超过图片
						autoCropArea: 0.8, // 自动裁剪区域大小
						movable: true, // 可移动图片
						rotatable: true, // 可旋转
						scalable: true, // 可缩放
						zoomable: true, // 可放大缩小
						cropBoxMovable: true, // 可移动裁剪框
						cropBoxResizable: true, // 可调整裁剪框大小
						background: true, // 显示背景
						responsive: true, // 响应式
						checkCrossOrigin: false
					});
				}
			});
		},

		// 确认裁剪
		confirmCrop() {
			if (!this.cropper) return;

			// 获取裁剪后的canvas
			const canvas = this.cropper.getCroppedCanvas({
				width: 200, // 输出宽度
				height: 200, // 输出高度
				minWidth: 100,
				minHeight: 100,
				maxWidth: 800,
				maxHeight: 800,
				fillColor: '#fff', // 填充色
				imageSmoothingEnabled: true,
				imageSmoothingQuality: 'high'
			});

			if (canvas) {
				// 转换为Base64
				const base64 = canvas.toDataURL('image/jpeg', 0.9); // 质量为90%的JPEG
				// 保存Base64数据
				this.croppedAvatarUrl = base64;
				this.showCropperModal = false;

			}
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
			})
		},
		changeProvices() {
			this.set_province_city();
			this.form.city_id = ""
			this.form.district_id = ""
			this.district = []
			this.getcitys();
		},
		changeCity() {
			this.set_province_city();
			this.form.district_id = ""
			this.getdistrict();
		},
		changeDistrict() {
			this.set_province_city();
		},
		set_province_city() {
			this.province_city = '';
			var obj = this;
			var name = '';
			this.provices.forEach(function(item) {
				if (item.id == obj.form.province_id) {
					name = item.name
				}
			})
			this.city.forEach(function(item) {
				if (item.id == obj.form.city_id) {
					name = name + item.name
				}
			})
			this.district.forEach(function(item) {
				if (item.id == obj.form.district_id) {
					name = name + item.name
				}
			})
			this.form.province_city = name;
		},
		async getdistrict() {
			await this.$axios.post('/api/yunsys.Website/getcitys', { id: this.form.city_id }).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						this.district = []
					} else {
						this.district = res.data;
						this.set_province_city();
					}

				})
				.catch(err => {
					this.district = []
				})
		},
		async getcitys() {
			await this.$axios.post('/api/yunsys.Website/getcitys', { id: this.form.province_id }).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						this.city = []
					} else {
						this.city = res.data;
						this.set_province_city();
					}

				})
				.catch(err => {
					this.city = []
				})
		},
		async getProvices() {
			await this.$axios.post('/api/yunsys.Website/getProvices').then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						this.provices = []
					} else {
						this.provices = res.data;
						this.set_province_city();
					}

				})
				.catch(err => {
					this.provices = []
				})
		},
		async getusermsg() {
			await this.$axios.post('/api/yunsys.Website/getusermsg').then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {

					} else {


						this.userinfo=res.data
						this.user_id = res.data.id;
						this.expire_date = res.data.expire_date;
						this.state = res.data.state;
						this.user_id = res.data.id;
						this.form.linkman = res.data.linkman;
						this.form.is_open = res.data.is_open == 1 ? true : false;
						this.form.province_id = res.data.province_id ? res.data.province_id : '';
						this.form.city_id = res.data.city_id ? res.data.city_id : '';
						this.form.district_id = res.data.district_id ? res.data.district_id : '';
						this.form.company_address = res.data.company_address;
						if (res.data.user_img) {
							this.croppedAvatarUrl = this.$axios.defaults.baseURL + res.data.user_img;
						}
						this.getcitys();
						this.getdistrict();



						this.username = res.data.username;
						this.mobile = res.data.mobile;
						this.code = res.data.code;
						this.form.username = res.data.username;
						this.form.mobile = res.data.mobile;
						this.form1 = {
							companyName: res.data.companyName,
							companyType: res.data.companyType,
							legalPerson: res.data.legalPerson,
							taxCode: res.data.taxCode,
							bankName: res.data.bankName,
							bankAccount: res.data.bankAccount,
							invoiceAddr: res.data.invoiceAddr,
							invoicePhone: res.data.invoicePhone,
							bus_state: res.data.bus_state,
							reason: res.data.reason,
							img_business: res.data.img_business ? (this.$axios.defaults.baseURL + res.data.img_business):'',
							authFileUrl: res.data.authFileUrl ? (this.$axios.defaults.baseURL + res.data.authFileUrl):'',
							img_qualily: res.data.img_qualily ? (this.$axios.defaults.baseURL + res.data.img_qualily):'',
						}


					}

				})
				.catch(err => {
					console.log(err)
				})
		},

		async saveuser_company() {
			var obj = this;
			this.$refs.formData1.validate(async v => {
				if (v) {
					this.loading = true
					await this.$axios.post('/api/yunsys.website/savebususer', this.form1).then(async (res) => {
							var res = res.data;
							this.loading = false
							if (res.code !== 0) {
								return ElMessage({
									message: res.msg,
									type: 'error',
									grouping: true // 开启合并功能
								})
							}
							this.getusermsg();
							this.save_info1 = true
							return ElMessage({
								message: res.msg,
								type: 'success',
								grouping: true // 开启合并功能
							})

						})
						.catch(err => {
							this.loading = false
							return ElMessage({
								message: '系统错误',
								type: 'error',
								grouping: true // 开启合并功能

							})
						})
				} else {
					return ElMessage({
						message: '请填写必填项',
						type: 'error',
						grouping: true // 开启合并功能

					})
				}
			})
		},
		async saveuser() {
			var obj = this;
			this.form.user_img = this.croppedAvatarUrl;
			this.$refs.formData.validate(async v => {
				if (v) {
					this.loading = true
					await this.$axios.post('/api/yunsys.Website/saveuser', this.form).then(async (res) => {
							var res = res.data;
							this.loading = false
							if (res.code !== 0) {
								return ElMessage({
									message: res.msg,
									type: 'error',
									grouping: true // 开启合并功能
								})
							}
							this.getusermsg();
							this.save_info = true
							return ElMessage({
								message: res.msg,
								type: 'success',
								grouping: true // 开启合并功能
							})

						})
						.catch(err => {
							this.loading = false
							return ElMessage({
								message: '系统错误',
								type: 'error',
								grouping: true // 开启合并功能

							})
						})
				} else {
					return this.$message.error('请填写必填项')
				}
			})

		},
	}
}
</script>
<style lang="less" scoped>
.upload-demo {
	display: none
}

.avatar-uploader .avatar {
	width: 80px;
	height:80px;
	display: block;
}
.authFileUrl_w{
	//top: -3rem;
  	//position: absolute;
  	margin-top: 0.6rem;
  margin-bottom: 0.6rem;
}
.avatar-uploader :deep(.el-upload) {
	border: 1px dashed var(--el-border-color);
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
	border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 80px;
	height: 80px;
	text-align: center;
}

.avatar-upload-container {
	display: inline-block;
}

.company_img :deep(.el-form-item) {
	display: block !important;

}

.company_img :deep(.el-form-item__content) {
	text-align: right;
	display: block;
	width: 120px;


}
.company_img :deep(.el-form-item__label) {
	margin-bottom:40px
}
:deep(.el-dialog__body) {
	text-align: right;
}
.box {
  
}
/* 核心：伪元素实现「缩短的左边框」 */
.box::before {
  content: ''; /* 伪元素必须有content，空值即可 */
  position: absolute;
  top: 80px; /* 关键：距离顶部20px → 上边留空，边框缩短 */
  bottom: 20px; /* 关键：距离底部20px → 下边留空，边框缩短 */
  width: 1px; /* 边框的粗细，和border-left的width一致 */
  background-color: var(--el-border-color); /* 边框的颜色 */
}
.dialog-footer .el-button {
	margin-top: 10px;
	text-align: right;
}

.avatar-wrapper {
	width: 150px;
	height: 150px;
	border-radius: 50%;
	overflow: hidden;
	cursor: pointer;
	border: 2px dashed #dcdfe6;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
}

.avatar-image {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.avatar-placeholder {
	color: #909399;
	font-size: 14px;
	text-align: center;
}

.cropper-container {
	width: 100%;
	height: 500px;
}

.cropper-image {
	max-width: 100%;
	max-height: 100%;
	display: block;
}

:deep(.el-form-item) {
	margin-left: 10px;
	margin-bottom: 8px;
}

/* 隐藏边框 */
:deep(.el-input__wrapper) {
	box-shadow: none !important;
	border: none !important;
}

:deep(.el-select__wrapper.is-disabled) {
	background-color: #fff
}

:deep(.el-input.is-disabled .el-input__wrapper) {
	background-color: #fff
}
:deep(.el-tabs__content){
	margin-top: -3px;
}
/* 隐藏边框 */
:deep(.el-select__wrapper) {
	box-shadow: none !important;
	border: none !important;
}

/* 隐藏聚焦时的边框 */
:deep(.el-input__wrapper.is-focus) {
	box-shadow: none !important;
}

.triggerFileInput :deep(.el-form-item__content) {
	display: flex;
	justify-content: flex-end;
}

.user_name :deep(.el-form-item__label) {
	width: 100px !important;
}

.user_company :deep(.el-form-item) {
	margin-bottom: 2.3rem !important;
}
.company_img :deep(.el-form-item) {
	margin-bottom: 0rem !important;
}
:deep(.el-input-group__prepend) {
	box-shadow: none !important;
	border: none !important;
	background-color: #fff;
	padding-left: 10px;
}

:deep(.el-avatar) {
	margin-bottom: 60px;
}

:deep(.el-form-item__label) {
	font-weight: bold;
}

.bottom {
	margin-top: 50px
}
</style>